import { render, staticRenderFns } from "./kyc.vue?vue&type=template&id=458b88f5&scoped=true"
import script from "./kyc.vue?vue&type=script&lang=js"
export * from "./kyc.vue?vue&type=script&lang=js"
import style0 from "./kyc.vue?vue&type=style&index=0&id=458b88f5&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458b88f5",
  null
  
)

export default component.exports